export const addResultsImportData = {
    namespaced: true,

    state: {
        crewId: null,
        session: null,
        userId: null
    },

    getters: {
        userId(state) {
            return state.userId;
        },

        crewId(state) {
            return state.crewId;
        },

        session(state) {
            return state.session;
        }
    },

    mutations: {
        setUserId(state, data) {
            state.userId = data;
        },

        setCrewId(state, data) {
            state.crewId = data;
        },

        setSession(state, data) {
            state.session = data;
        },

        empty(state) {
            state.userId = null;
            state.crewId = null;
        }
    }
};

export default addResultsImportData;
